<template>
  <section class="ProductLegend">
    <div class="ProductLegend-list" :class="{showLegend: !hideLegend}">
      <p class="Text-bold" ref="ProductLegend" v-html="productLegend.shortDescription" :class="{hideLegend: hideLegend}"></p>
      <span v-if="!hideButton && hideLegend" class="ProductLegend-expendButton" @click="hideLegend = false">voir plus</span>
      <span v-if="!hideButton && !hideLegend" class="ProductLegend-expendButton" @click="hideLegend = true">voir moins</span>
    </div>

    <div class="ProductLegend-dimensionsAndShare">
      <div class="ProductLegend-dimensions">
        <p v-if="productLegend.title"><span class="Text-bold" :inner-html.prop="productLegend.title"></span></p>
        <p v-else><span class="Text-bold">Dimensions</span> (hors zones utiles)</p>
        <div class="ProductLegend-dimensionsInner">
          <svg
              v-svg
              :symbol="productLegend.icon"
              size="0 0 70 80"
              role="presentation"
              class="icon--inline"
          ></svg>
          <ul>
            <li
              v-for="(descriptionDimensions, indexDimensions) in productLegend.dimensions"
              :key="indexDimensions"
            >
              {{ indexDimensions }}
              <span class="Text-bold">{{ descriptionDimensions }} cm</span>
            </li>
          </ul>
        </div>
      </div>
    
    </div>

  </section>
</template>

<script>
import Icon from "@/components/Icon/Icon.vue";
import { mapGetters } from "vuex";

import "@/components/Product/ProductLegend/ProductLegend.scss";

export default {
  name: "ProductLegend",

  data() {
    return {
      hideLegend: false,
      hideButton: true,
    }
  },

  components: {
    Icon,
  },

  mounted() {
    if(this.$refs.ProductLegend.getBoundingClientRect().height > 270) {
      this.hideLegend = true;
      this.hideButton = false;
    }
  },

  computed: {
    ...mapGetters({ productLegend: "getProductLegend" }),
  },
};
</script>